import { Component, input } from '@angular/core';
import { SlicePipe } from '@angular/common';
import { Card, CardType } from '../../../../../../_interfaces/cards.interface';
import { EmptyIndicatorPipe } from '../../../../../../shared/pipes/empty-indicator.pipe';
import { AvatarComponent } from '../../../../../../shared/components/avatar/avatar.component';

@Component({
  selector: 'app-ng-select-card-dropdown-options',
  imports: [SlicePipe, EmptyIndicatorPipe, AvatarComponent],
  templateUrl: './ng-select-card-option-template.component.html',
})
export class NgSelectCardOptionTemplateComponent {
  item = input.required<Card>();
  isRecurring = input<boolean>();
  protected readonly CardType = CardType;
}
